import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import SalesOrder from "../../../containers/modules/sales/sales-order";

export default function SalesOrderRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="sales-order"
      index
      element={
        <AccessControl
          name={"Sales Order List"}
          auth={authUser}
          component={() => <SalesOrder />}
        />
      }
    />
  );
}
